module.exports = __webpack_public_path__ + "img/彭祥俊.51b96794.jpg";